import { CameraManagementApi, PointManagementApi } from '@wiz-api/haiguang'

const cameraManagement = new CameraManagementApi()
const pointManagement = new PointManagementApi()
/** ************************************************ 监控列表 **************************************** */
let tableData = []
let pointData = []
let markerList = []
let cloudRender
let propPlayer
const PROJECT_NAME = Wiz.globalSettings.globalConfig?.modelSetting?.folderName || 'SAAS'

// 创建摄像头标签
const createVideoMarker = async (player) => {
  const options = []
  tableData.forEach(async (val) => {
    if (!(val.pointData && val.pointData.position && val.pointData.icon)) {
      // console.log(`设备${val.cameraAlias}暂无点位`)
      return
    }
    // console.log(val, '当前绘制的点为')
    const pos = val.pointData.position.split(',')
    const style = val.pointData.icon
    const imgId = await PlayerUtils.call(
      player.Native.GisMarker.loadImage,
      `data://../apps/${PROJECT_NAME}/icon/${style}`
    )
    // console.log('传入的图片路径为：', style)
    const option = {
      pos, // 定位点，世界坐标，三维向量
      visible: true, // 显示隐藏状态
      size: [84, 98], // 整体尺寸，二维向量，-1表示不限制，自动大小
      nodeOffset: [-21, -49], // 相对定位点的偏移量，二维向量
      imgId, // 图片
      // backgroundUrl: `data://../apps/SAAS/icon/${style}`,
      imgSize: [44, 63], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
      imgOffset: [0, 0], // 图片相对标记的偏移量
      breakWidth: 250, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
      userData: null, // 用户数据，仅帮外部系统保存数据
    }
    options.push(option)
    const res = await player.Native.GisMarker.create(option)
    // markerList.push(res)
    markerList.push({
      id: val.id,
      pointId: res,
    })
    // console.log('当前的markerList为：', markerList)
  })
}

// 获取摄像头列表
const getTableList = async (player) => {
  const [err, res] = await cameraManagement.getCameraList({
    body: {
      maxResultCount: 999,
      skipCount: 0,
      sorting: '',
      tenantId: null,
      keyWords: '',
    },
  })
  if (!err) {
    tableData = res.items || []
    // 判断是否已经绑定点位
    _.forEach(tableData, (ele, index) => {
      tableData[index].status = false
      if (
        _.find(pointData, (item) => {
          ele.id === item.businessId ? (tableData[index].pointData = item) : ''
          return ele.id === item.businessId
        })
      ) {
        tableData[index].status = true
      }
    })
    createVideoMarker(player)
  }
}

// 获取点位列表
const getPointList = async (player, sceneId) => {
  const parmas = {
    sceneId,
    // sceneId: '3a1226b2-2cb7-0d02-0aec-81031e3d5401',
    type: 1,
  }
  const [err, res] = await pointManagement.getScenePoints(parmas)
  if (!err) {
    pointData = res
    await getTableList(player, sceneId)
  } else {
    app.$message.error(res.message)
  }
}

const create = async (player, sceneId, propcloudRender) => {
  cloudRender = propcloudRender
  propPlayer = player
  if (tableData.length) {
    createVideoMarker(player)
  } else {
    await getPointList(player, sceneId)
  }
  player.Native.GisMarker.EventGisMarkerLClick.connect((data) => {
    const currentMarker = _.find(markerList, (ele) => {
      return ele.pointId === data.markerId
    })
    if (currentMarker) {
      const currentData = _.find(tableData, (ele) => {
        return ele.id === currentMarker.id
      })
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: { code: 'VideoInfo', origin: 'tag', name: '摄像头信息' },
          type: 'tags',
          props: {
            videoRow: currentData,
          },
        },
      })
      window.dispatchEvent(openEvent)
    }
  })
}

const destroy = async (player) => {
  // console.log('当前destroy的markerList为：', markerList)
  // player.Native.GisMarker.batchDestroy(markerList)
  player.Native.GisMarker.batchDestroy(
    _.map(markerList, (ele) => {
      return ele.pointId
    })
  )
  markerList = []
}

const toggleDisplay = async (type) => {
  markerList = []
  await createVideoMarker(propPlayer)
  // console.log('当前toggle的markerList为：', markerList)
  await cloudRender.Marker.updateByPicture(
    map(markerList, (item) => {
      return {
        id: item.pointId,
        visible: type,
      }
    })
  )
}

// 隐藏标签
const hidden = async () => {
  await toggleDisplay(false)
}

// 重新显示标签
const display = async () => {
  await toggleDisplay(true)
}

// export { markerList, cameraList }
export default { create, destroy, hidden, display }
